import { useTranslation } from "next-i18next";
import { useNavigateOnSelect } from "src/components/common/typeahead/hooks/use-navigate-on-select";
import { useQueryWithSearchResults } from "src/components/common/typeahead/hooks/use-query-with-search-results";
import { ISearchResultsMutationVariables } from "src/components/common/typeahead/hooks/use-search-results";
import { UnderlyingSearchResults } from "src/components/common/typeahead/results/underlying-search-results";
import { ITypeaheadWrapper, Typeahead } from "src/components/common/typeahead/typeahead";
import { EnumSecurityType } from "src/types/common-enum";

const STOCK_SEARCH_MUTATION_VARIABLES: ISearchResultsMutationVariables = {
    wikifoliosCount: 0,
    underlyingsCount: 10,
    securityTypes: [EnumSecurityType.Stock],
};

export const StockTypeaheadWrapper = ({ onFocus, placement, placeholderText: searchPlaceholderText, enableAutoFocus }: ITypeaheadWrapper) => {
    const { t } = useTranslation("underlying-overview");
    const { query, setQuery, results, combinedResults, onClear } = useQueryWithSearchResults(STOCK_SEARCH_MUTATION_VARIABLES);
    const { handleSelect } = useNavigateOnSelect(results);

    return (
        <Typeahead
            placeholderText={searchPlaceholderText}
            enableAutoFocus={enableAutoFocus}
            placement={placement}
            query={query}
            combinedResults={combinedResults}
            setQuery={setQuery}
            onFocus={onFocus}
            onClear={onClear}
            onSelect={handleSelect}
        >
            {({ isOpen, selectedIndex }) =>
                isOpen &&
                results && (
                    <UnderlyingSearchResults
                        resultsTitle={t("stocks")}
                        notFoundMessage={t("stocks-not-found")}
                        results={results}
                        selectedIndex={selectedIndex}
                        query={query}
                    />
                )
            }
        </Typeahead>
    );
};
